import { cn } from '@distribute/frontend/utils';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

type Props = HTMLAttributes<HTMLTableSectionElement> & {
  className?: string;
};

export const TableHeader: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <thead
      {...props}
      className={cn('text-xs font-medium text-gray-600 bg-gray-100', className)}
    >
      {children}
    </thead>
  );
};
